/* eslint-disable-next-line */
import { useLocation } from '@reach/router';

import { Typography } from '@material-ui/core';
import { navigate } from 'gatsby';
import { makeStyles } from '@material-ui/core/styles';
import { scroller } from 'react-scroll';
import * as React from 'react';

const useStyles = makeStyles((theme) => ({
  navigation: {
    display: 'flex',
    color: theme.motorX.darkGray,
    flexDirection: 'column',
  },
  navigationLink: {
    color: theme.motorX.darkGray,
    textTransform: 'uppercase',
    padding: theme.spacing(1, 0),

    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
}));

const Navigation = () => {
  const classes = useStyles();
  const location = useLocation();

  const navigateAndScroll = (path, element) => {
    if (location.pathname !== path) {
      navigate(path);
    }

    setTimeout(
      () =>
        scroller.scrollTo(element, {
          smooth: 'easeInOut',
        }),
      100,
    );
  };

  return (
    <div className={classes.navigation}>
      <Typography variant="subtitle1">
        <button
          type="button"
          onClick={() => navigate('/')}
          className={classes.navigationLink}
        >
          Inicio
        </button>
      </Typography>

      <Typography variant="subtitle1">
        <button
          className={classes.navigationLink}
          type="button"
          onClick={() => navigate('/search')}
        >
          Tienda
        </button>
      </Typography>

      <Typography variant="subtitle1">
        <button
          className={classes.navigationLink}
          type="button"
          onClick={() => navigateAndScroll('/', 'index-services')}
        >
          Servicios
        </button>
      </Typography>

      <Typography variant="subtitle1">
        <button
          className={classes.navigationLink}
          type="button"
          onClick={() => navigate('/our-history')}
        >
          Historia
        </button>
      </Typography>

      <Typography variant="subtitle1">
        <button
          className={classes.navigationLink}
          type="button"
          onClick={() => navigateAndScroll('/', 'index-contact')}
        >
          Contacto
        </button>
      </Typography>
    </div>
  );
};

export default Navigation;
